"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var CheckCircleOffOutline = function CheckCircleOffOutline(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M20.4746 23.3L17.5246 20.35C16.7246 20.8833 15.8621 21.2917 14.9371 21.575C14.0121 21.8583 13.0329 22 11.9996 22C10.6162 22 9.31623 21.7375 8.09956 21.2125C6.88289 20.6875 5.82456 19.975 4.92456 19.075C4.02456 18.175 3.31206 17.1167 2.78706 15.9C2.26206 14.6833 1.99956 13.3833 1.99956 12C1.99956 10.9667 2.14123 9.9875 2.42456 9.0625C2.70789 8.1375 3.11623 7.275 3.64956 6.475L0.674561 3.5L2.09956 2.075L21.8996 21.875L20.4746 23.3ZM11.9996 20C12.7496 20 13.4621 19.9 14.1371 19.7C14.8121 19.5 15.4496 19.225 16.0496 18.875L12.1746 15L10.5996 16.6L6.34956 12.35L7.74956 10.95L10.5996 13.8L10.7746 13.6L5.12456 7.95C4.77456 8.55 4.49956 9.1875 4.29956 9.8625C4.09956 10.5375 3.99956 11.25 3.99956 12C3.99956 14.2167 4.77873 16.1042 6.33706 17.6625C7.89539 19.2208 9.78289 20 11.9996 20ZM20.3746 17.5L18.8996 16.025C19.2496 15.4417 19.5204 14.8125 19.7121 14.1375C19.9037 13.4625 19.9996 12.75 19.9996 12C19.9996 9.78333 19.2204 7.89583 17.6621 6.3375C16.1037 4.77917 14.2162 4 11.9996 4C11.2496 4 10.5371 4.09583 9.86206 4.2875C9.18706 4.47917 8.55789 4.75 7.97456 5.1L6.49956 3.625C7.29956 3.10833 8.16206 2.70833 9.08706 2.425C10.0121 2.14167 10.9829 2 11.9996 2C13.3829 2 14.6829 2.2625 15.8996 2.7875C17.1162 3.3125 18.1746 4.025 19.0746 4.925C19.9746 5.825 20.6871 6.88333 21.2121 8.1C21.7371 9.31667 21.9996 10.6167 21.9996 12C21.9996 13.0167 21.8579 13.9875 21.5746 14.9125C21.2912 15.8375 20.8912 16.7 20.3746 17.5ZM15.0496 12.15L13.6496 10.75L16.2496 8.15L17.6496 9.55L15.0496 12.15Z",
    fill: "#currentColor"
  }));
};

var _default = CheckCircleOffOutline;
exports.default = _default;